import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useChartPeriod } from '@/hooks';
import { FormattedNumber, LineChart, formatNumber } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';

export default function CdpsChart({ what }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const yAxisConfig = {
    options: {
      scales: {
        y: {
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  };
  const config = updateChartConfigWithPeriod(yAxisConfig);
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: `/lse/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const key = what === 'borrowers' ? 'number_of_borrowers' : 'number_of_urns';
    return (
      <LineChart
        key={key}
        data={data}
        datasets={[
          {
            xField: 'date',
            yField: key
          }
        ]}
        valueFormatter={(value: number) => (
          <FormattedNumber
            value={Number(value)}
            options={{ formatNumberOptions: { notation: 'standard' } }}
          />
        )}
        yScaleValueFormatter={(value: number) =>
          formatNumber(value, { notation: 'standard' })
        }
        timeFilter={timeFilter}
        config={config}
      />
    );
  }

  return <ChartSkeleton />;
}
